export const DB_CLUSTER_INVENTORY_URL = '/dbaas/dbclusters';
export const DB_CLUSTER_CREATION_URL = `${DB_CLUSTER_INVENTORY_URL}/creation`;
export const DB_CLUSTER_EDIT_URL = `${DB_CLUSTER_INVENTORY_URL}/edit`;
